import { onGetUserInfo } from "@/api/common"
import { persistOptions } from "@/store/_persist"
import { defineStore } from "pinia"

const INITIAL_USER_INFO = {
  nickname: "",
  avatar: "",
  mobile: "",
  openid: "",
  role: "user",
}

export const useUserStore = defineStore("user", {
  state: () => ({
    // TODO 根据自己项目拓展
    userInfo: { ...INITIAL_USER_INFO },
    token: null,
  }),

  getters: {
    isLogin: (state) => !!state.token,
    getToken: (state) => state.token,
    // 用户的角色, 字段根据实际项目来修改
    userRole: (state) => state.userInfo.role,
  },

  actions: {
    /**
     * 登录
     *
     * 模板默认未提供后端接口,业务层接入时:
     *  1. 调用项目自身的登录接口
     *  2. 成功后调用 setToken / setUserInfo
     *  3. 失败时调用 useToast 提示
     */
    async onLogin(formData) {
      throw new Error(
        "useUserStore.onLogin 尚未接入业务接口,请在 store/useUserStore.js 中实现",
      )
    },
    setToken(value) {
      this.token = value
    },
    /**
     * 刷新用户信息
     */
    async setUserInfo() {
      const res = await onGetUserInfo()
      if (res.code === 200) {
        this.userInfo = res.data
      }
    },
    clearUserInfo() {
      this.userInfo = { ...INITIAL_USER_INFO }
      this.token = null
    },
    setUserRole(role) {
      this.userInfo.role = role
    },
  },

  persist: persistOptions("user-store"),
})
